import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "isSelected", "isFocused", "onSelect", "data", "onFocus", "onBlur", "isRequired"];
import React, { useCallback, useMemo } from 'react';
import { Box, Text, Link } from '../';
import getConfig from '../../js/settings';
import { appendHtmlClass, getAnimationDuration, getAnimationEasing } from '../../js/util';
import './_index.scss';
var OPTION_ANIMATION_DURATION = getConfig('OPTION_ANIMATION_DURATION');
var OptionMemo = /*#__PURE__*/React.memo(function Option(_ref) {
  var className = _ref.className,
    isSelected = _ref.isSelected,
    isFocused = _ref.isFocused,
    onSelect = _ref.onSelect,
    data = _ref.data,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    isRequired = _ref.isRequired,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var onClick = useCallback(function (e) {
    return typeof onSelect === 'function' && onSelect(data.id, e);
  }, [onSelect, data.id]);
  var onMouseEnter = useCallback(function (e) {
    return typeof onMouseEnter === 'function' && onFocus(data.id, e);
  }, [data.id, onFocus]);
  var onMouseLeave = useCallback(function (e) {
    return typeof onMouseLeave === 'function' && onBlur(data.id, e);
  }, [data.id, onBlur]);
  var animationProps = useMemo(function () {
    var hidden = {
      opacity: 0
    };
    var visible = {
      opacity: 1
    };
    return {
      isAnimated: true,
      variants: {
        hidden: hidden,
        visible: visible
      },
      initial: 'hidden',
      transition: {
        duration: getAnimationDuration(OPTION_ANIMATION_DURATION),
        ease: getAnimationEasing('ease')
      }
    };
  }, []);
  var newClassName = useMemo(function () {
    var result = appendHtmlClass(className, 'option');
    if (isFocused) result = appendHtmlClass(result, 'focus');
    if (isSelected) result = appendHtmlClass(result, 'selected');
    return result;
  }, [className, isFocused, isSelected]);
  return /*#__PURE__*/React.createElement(Box, Object.assign({
    as: "li",
    className: newClassName,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, animationProps, rest), /*#__PURE__*/React.createElement(Link, {
    className: "option-link",
    type: "raw",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Text, {
    as: "div",
    className: "option-text"
  }, data.label)));
});
OptionMemo.defaultProps = {
  isSelected: false,
  isFocused: false
};
export default OptionMemo;